/* __next_internal_client_entry_do_not_use__ default auto */ import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Suspense } from "react";
import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import styles from "../page.module.scss";
import { endTime } from "../config";
import { isDateAfter } from "@/shares/utils/date";
export default function Header() {
    const translationPageKey = "Tomarket_activity";
    const t = useTranslations("");
    const [showStatic, setShowStatic] = useState(true);
    useEffect(()=>{
        // 1.5秒后隐藏静态图片
        setTimeout(()=>{
            setShowStatic(false);
        }, 500);
    }, []);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "mt-[24px] w-[200px] h-[160px]",
                children: [
                    showStatic ? /*#__PURE__*/ _jsx("div", {
                        className: styles.headerImg
                    }) : null,
                    /*#__PURE__*/ _jsx(Suspense, {
                        fallback: /*#__PURE__*/ _jsx("div", {
                            className: styles.headerImg
                        }),
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "w-[200px] h-[160px]",
                            children: /*#__PURE__*/ _jsx(DotLottieReact, {
                                src: "/hunt.json",
                                autoplay: true,
                                loop: true
                            })
                        })
                    })
                ]
            }),
            /*#__PURE__*/ _jsxs("div", {
                className: "flex flex-col items-center w-full  mt-[12px] text-[#0D0E0E]",
                children: [
                    /*#__PURE__*/ _jsx("h1", {
                        className: "text-[18px] font-600 leading-[26px]",
                        children: "".concat(t("".concat(translationPageKey, "_title")))
                    }),
                    !isDateAfter(endTime) ? /*#__PURE__*/ _jsx("h2", {
                        className: "mt-[4px] text-[14px] font-400 leading-[22px]",
                        children: t("".concat(translationPageKey, "_description"))
                    }) : null,
                    !isDateAfter(endTime) ? /*#__PURE__*/ _jsxs("div", {
                        className: "w-fit px-[12px] py-[4px] mt-[8px] text-[#515656] text-[14px] leading-[22px] bg-[rgba(255,145,14,0.10)] border-1 border-solid border-[rgba(254,91,121,0.10)] rounded-[20px]",
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                children: t("".concat(translationPageKey, "_dateline"))
                            }),
                            /*#__PURE__*/ _jsx("span", {
                                className: "font-600",
                                children: "December 22nd 23:59 UTC+8"
                            })
                        ]
                    }) : null
                ]
            })
        ]
    });
}
